const DEFAULT_RATE_LIMIT_WAIT_MS = 3000;
const MIN_RATE_LIMIT_WAIT_MS = 1000;
const MAX_RATE_LIMIT_WAIT_MS = 20000;

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

function parseResetMs(reset) {
  if (typeof reset === 'number' && Number.isFinite(reset)) {
    return reset * 1000;
  }
  if (typeof reset !== 'string' || reset.trim() === '') {
    return undefined;
  }

  const match = reset.trim().match(/^(\d+(?:\.\d+)?)(ms|s|m)?$/);
  if (!match) return undefined;

  const value = Number(match[1]);
  if (!Number.isFinite(value)) return undefined;

  if (match[2] === 'ms') return value;
  if (match[2] === 'm') return value * 60 * 1000;
  return value * 1000;
}

export function rateLimitRetryDelayMs(reset, attempt = 0) {
  const parsed = parseResetMs(reset);
  const fallback = DEFAULT_RATE_LIMIT_WAIT_MS * Math.max(1, attempt + 1);
  const waitMs = Number.isFinite(parsed) ? parsed : fallback;
  return Math.min(Math.max(waitMs, MIN_RATE_LIMIT_WAIT_MS), MAX_RATE_LIMIT_WAIT_MS);
}

export function isCallableRateLimitError(error) {
  const code = error?.code || '';
  return code === 'resource-exhausted' || code === 'functions/resource-exhausted';
}
